import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Paper,
  Divider,
  Select,
  IconButton,
  Button,
  MenuItem,
  Menu,
  Pagination,
  PaginationItem,
  Stack,
  Grid,
  TextField,
  InputAdornment,
} from "@mui/material";
import { TOTALLIMIT } from "../../../utils/localStorage";
import { styled } from "@mui/material/styles";
import EditButton from "../../../assets/icons/EditButton.svg";
import TrashButton from "../../../assets/icons/TrashButton.svg";
import Switch from "@mui/material/Switch";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import ButtonAdd from "../../../assets/icons/ButtonAdd.svg";
import noData from "../../../assets/images/Group 688.png";
import React, { useState, useEffect } from "react";
import BackArrow from "../../../assets/icons/BackArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import AddVesselMasterModel from "./AddVesselMasterModel";
import EditVesselMasterModel from "./EditVesselMasterModel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CircularProgress from "@mui/material/CircularProgress";
import {
  deleteVesselMastersList,
  getVesselMasterList,
  updateVesselMastersList,
  setIsOpenModelAddVesselMaster,
  setIsOpenModelEditVesselMaster,
} from "../../../redux/actions/mastersAction";
import ConformationModel from "../../CommonComponent/ConformationModel";
import DeleteModel from "../../CommonComponent/DeleteModel";
import { Search } from "@mui/icons-material";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import { GenerateDisplayId } from "../../../utils/GenerateDisplayId";
import { setLoaderSaveButton } from "../../../redux/actions/userActions";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#26875C" : "#26875C",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const VesselMasterContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state?.user?.isLoading);

  const vesselMasterPagination = useSelector(
    (state) => state?.masters?.vesselMasterPagination
  );

  const vesselMasterData = useSelector(
    (state) => state?.masters?.vesselMasterData
  );

  const [isdeleteModel, setIsdeleteModel] = useState(false);

  const [vesselMasterDeleteID, setVesselMasterDeleteID] = useState("");
  const [isActive, setIsActive] = useState("true");
  const [FirstNameSearchValue, setFirstNameSearchValue] = useState("");
  const [isConformationModel, setIsConformationModel] = useState(false);
  const [ConformationRowData, setConformationRowData] = useState("");
  const [isPaginationLimit, setIsPaginationLimit] = useState(10);
  const [page, setPage] = useState(1);

  const handleChangeIsPaginationLimit = (event) => {
    setIsPaginationLimit(event.target.value);
  };

  const handleChangePage = (e, pagevalue) => {
    setPage(pagevalue);
  };
  const handleChangeIsActive = (event) => {
    setIsActive(event.target.value);
  };

  const handleChangeFirstNameSearchValue = (event) => {
    setFirstNameSearchValue(event.target.value);
  };

  useEffect(() => {
    dispatch(
      getVesselMasterList({
        active: isActive,
        searchByFirstName: FirstNameSearchValue,
        limit: isPaginationLimit,
        offset: page - 1,
      })
    );
  }, [isActive, FirstNameSearchValue, isPaginationLimit, page]);

  const handleDeleteVesselMaster = () => {
    dispatch(
      deleteVesselMastersList({
        id: vesselMasterDeleteID,
      })
    );
    handleClosedeleteModel();
  };

  const handleClosedeleteModel = (e) => {
    setIsdeleteModel(false);
  };

  const handleConformationModel = (e) => {
    setIsConformationModel(false);
  };

  const handleConformationUpdate = () => {
    dispatch(
      updateVesselMastersList({
        active: !ConformationRowData?.active,
        id: ConformationRowData?.id,
      })
    );
  };

  const toggleActiveStatus = (Vesselrow) => {
    dispatch(
      updateVesselMastersList({
        active: !Vesselrow?.active,
        id: Vesselrow?.id,
      })
    );
  };

  const onExportHandler = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportFormShape = vesselMasterData.map((user, index) => {
      return {
        ID: `VT${(index + 1).toString().padStart(3, "0")}`,
        "Vessel Name": user.name,
        "Vessel Type Name": user?.vesselType?.name,
        "Created Date And Time": moment(user?.createdAt).format(
          "D MMMM, YYYY | hh:mm A"
        ),
        "Modified Date And Time": moment(user?.updatedAt).format(
          "D MMMM, YYYY | hh:mm A"
        ),
      };
    });
    const ws = XLSX.utils.json_to_sheet(exportFormShape);

    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "Vessel Master" + fileExtension);
  };

  const handleEditVessel = (VesselRowData) => {
    const payload = {
      isOpenEditModel: true,
      EditRowDataModel: VesselRowData,
    };
    dispatch(setIsOpenModelEditVesselMaster(payload));
  };

  useEffect(() => {
    dispatch(setIsOpenModelAddVesselMaster(false));
    const payload = {
      isOpenEditModel: false,
      EditRowDataModel: [],
    };
    dispatch(setIsOpenModelEditVesselMaster(payload));
    dispatch(setLoaderSaveButton(false));
  }, []);

  return (
    <>
      <AddVesselMasterModel />

      <EditVesselMasterModel />

      {isdeleteModel && (
        <DeleteModel
          isdeleteModel={isdeleteModel}
          handleClosedeleteModel={handleClosedeleteModel}
          handleDelete={handleDeleteVesselMaster}
        />
      )}
      {isConformationModel && (
        <ConformationModel
          isConformationModel={isConformationModel}
          handleConformationModel={handleConformationModel}
          handleConformationUpdate={handleConformationUpdate}
        />
      )}
      <Paper
        sx={{
          width: "auto",
          height: "auto",
          overflow: "auto",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            overflow: "auto",
            width: "auto",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                display: "flex",
                ml: 2,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/masters");
              }}
            >
              <img src={BackArrow} alt="" width="17" height="17" />
            </Box>
            <Box>
              <Typography
                sx={{
                  ml: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Vessel Master
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex" }}>
            <Select
              value={isActive}
              onChange={handleChangeIsActive}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              IconComponent={() => (
                <Box
                  sx={{
                    marginRight: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={ArrowDown}
                    alt="Custom Icon"
                    width="16"
                    height="24"
                  />
                </Box>
              )}
              sx={{
                height: "37px",
                width: "11rem",
                color: "#20724E",
                fontWeight: "bold",
                borderRadius: "10px",
                backgroundColor: "#E5F1EB",
                border: "none",
                mr: 2,
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #E5F1EB",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="true">Active</MenuItem>
              <MenuItem value="false">In Active</MenuItem>
            </Select>
            {/* <Box> */}
            <TextField
              size="small"
              placeholder="Search Vessel Name"
              value={FirstNameSearchValue}
              onChange={handleChangeFirstNameSearchValue}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ color: "#20724E" }} />
                  </InputAdornment>
                ),
                style: {
                  height: "2.3rem",
                  borderRadius: "10px",
                  color: "#20724E",
                  fontWeight: "bold",
                  width: "15rem",
                  backgroundColor: "#E5F1EB",
                },
              }}
              sx={{
                mr: 2,
                ml: 1,
                border: "none",
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #E5F1EB",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            {/* </Box> */}
            <Button
              variant="contained"
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                width: "12rem",
                marginRight: "15px",
                backgroundColor: "#26875C",
                padding: "8px 15px 5px 10px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#FFFFFF",
                ":hover": {
                  backgroundColor: "#26875C",
                },
              }}
              onClick={() => dispatch(setIsOpenModelAddVesselMaster(true))}
            >
              <Box sx={{ marginRight: "10px" }}>
                <img src={ButtonAdd} alt="" />
              </Box>
              Add Vessel
            </Button>
            <Button
              variant="contained"
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                width: "6rem",
                backgroundColor: "#26875C",
                padding: "7px 0px 5px 0px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#FFFFFF",
                mr: "10px",
                ":hover": {
                  backgroundColor: "#26875C",
                },
              }}
              // onClick={() => setIsEditManagementMasterModel(true)}
              onClick={() => (isLoading ? null : onExportHandler())}
            >
              Export
            </Button>
          </Box>
        </Box>
        <Divider sx={{ width: "auto" }} />

        <Box sx={{ margin: "10px 25px 20px 25px" }}>
          <TableContainer
            sx={{
              maxHeight: "620px",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            {vesselMasterData.length <= 0 ? (
              <Grid sx={{ paddingTop: "20px" }}>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Box
                      component="img"
                      sx={{
                        height: "25rem",
                        width: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      alt=""
                      src={noData}
                    />
                  </Box>
                  <Box
                    fontWeight="600"
                    sx={{ padding: "20px", fontWeight: "600" }}
                  >
                    <Typography sx={{ fontWeight: "600", fontSize: "18px" }}>
                      No Data Found
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      ID
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Vessel Name
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Vessel Type Name
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Imo Number
                    </TableCell> */}
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Created Date and Time
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Modified Date and Time
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Action
                    </TableCell>
                    <TableCell
                      sx={{ color: "#B5B5C3", fontWeight: 600 }}
                    ></TableCell>
                  </TableRow>
                </TableHead>
                {isLoading ? (
                  <TableBody>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        height: "10rem",
                      }}
                    >
                      <TableCell colSpan={8} align="center">
                        <CircularProgress color="success" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {vesselMasterData?.map((row, index) => (
                      <TableRow
                        // key={row.Checklist}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          sx={{
                            color: "#464E5F",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {`V${(index + 1).toString().padStart(3, "0")}`}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row.name}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row?.vesselType?.name}
                        </TableCell>
                        {/* <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row?.imo_number}
                        </TableCell> */}
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {moment(row?.createdAt).format(
                            "D MMMM, YYYY | hh:mm A"
                          )}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {moment(row?.updatedAt).format(
                            "D MMMM, YYYY | hh:mm A"
                          )}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          <Box
                            onClick={() => {
                              if (row.active === false) {
                                toggleActiveStatus(row);
                              } else {
                                setConformationRowData(row);
                                setIsConformationModel(true);
                              }
                            }}
                          >
                            <AntSwitch checked={row.active} color="primary" />
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "#464E5F",
                            fontWeight: 600,
                            display: "flex",
                          }}
                        >
                          <IconButton>
                            <img
                              src={EditButton}
                              width="30"
                              height="30"
                              onClick={() => handleEditVessel(row)}
                            />
                          </IconButton>
                          {/* <IconButton
                            onClick={() => {
                              setVesselMasterDeleteID(row?.id);
                              setIsdeleteModel(true);
                            }}
                          >
                            <img src={TrashButton} width="30" height="30" />
                          </IconButton> */}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            )}
          </TableContainer>
          <Divider />
          {vesselMasterPagination?.totalRecord >= TOTALLIMIT && (
            <Stack
              spacing={2}
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{
                padding: "1rem",
                marginTop: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ mr: "8px" }}>Row Per Page</Typography>
                <Select
                  value={isPaginationLimit}
                  onChange={handleChangeIsPaginationLimit}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  IconComponent={() => (
                    <Box
                      sx={{
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ArrowDown}
                        alt="Custom Icon"
                        width="18"
                        height="24"
                      />
                    </Box>
                  )}
                  sx={{
                    height: "37px",
                    width: "6rem",
                    color: "#20724E",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    border: "none",
                    backgroundColor: "#E5F1EB",
                    mr: 2,
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #E5F1EB",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={30}>30</MenuItem>
                </Select>
              </Box>
              <Box>
                <Pagination
                  count={vesselMasterPagination?.totalPages}
                  onChange={handleChangePage}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{
                        previous: ArrowBackIcon,
                        next: ArrowForwardIcon,
                      }}
                      {...item}
                    />
                  )}
                />
              </Box>
            </Stack>
          )}
        </Box>
      </Paper>
    </>
  );
};

export default VesselMasterContent;
